import React from "react";
import { Outlet, Navigate } from "react-router-dom";

import App from "./../app.jsx";

import ExtraError from "./../pages/extra/extra-error.js";
import LoginV1 from "./../pages/user/login-v1.js";
import LoginV2 from "./../pages/user/login-v2.tsx";
import LoginV3 from "./../pages/user/login-v3.js";
import Logout from "./../pages/user/Logout.tsx";
import RegisterV3 from "./../pages/user/register-v3.js";
import HelperCSS from "./../pages/helper/helper-css.js";
import FormPreguntasInciales from "../pages/preguntas-iniciales/form.js";
import Confirmation from "../pages/preguntas-iniciales/confirmation.js";
import FormPostulante from "../pages/postulante/form.js";
import FormResult from "../pages/result/form.js";
import Solicitudes from "../pages/solicitudes/lista.js";
import TalentoHumano from "../pages/talento-humano/lista.js";
import Calendar from "../pages/calendar/calendar.js";
import LeaderCalendar from "../pages/calendar/LeaderCalendar.tsx";
import ListUsers from "../pages/user/ListUsers.tsx";
import Dashboard from "../pages/Dashboard.tsx";
import FormElements from "../pages/form/form-elements.js";
import FormPlugins from "../pages/form/form-plugins.js";
import NewUser from "../pages/user/NewUser.tsx";
import EditUser from "../pages/user/EditUser.tsx";
import Historial from "../pages/postulante/Historial.tsx";
import Print from "../pages/postulante/Print.tsx";
// import Catalog from "../pages/catalog/catalog.js";
import ListCatalog from "../pages/catalog/ListCatalog.tsx";
import FetchCollaborator from "../pages/postulante/FetchCollaborator.tsx";
import Vacantes from "../pages/vacantes/list.tsx";
import VacantesV2 from "../pages/vacantes/listV2.tsx";
import ListColaboradores from "../pages/colaboradores/ListColaboradores.tsx";
import ListListaNegra from "../pages/lista-negra/ListListaNegra.tsx";
import ListSolicitudes from "../pages/solicitudes/ListSolicitudes.tsx";
import CandidateTracking from "../pages/solicitudes/CandidateTracking.tsx";
import ProfilePartner from "../pages/profile-partner/ProfilePartner.tsx";
import Puestos from "../pages/puestos/Puestos.tsx";
import NewPosition from "../pages/puestos/NewPosition.tsx";
import EditPosition from "../pages/puestos/EditPosition.tsx";
import DocumentsReview from "../pages/documents/DocumentsReview.tsx";
import MyExpedient from "../pages/worker/MyExpedient.tsx";
import Tallas from "../pages/catalogo/Tallas.tsx";
import Catalogo from "../pages/catalogo/Catalogo.tsx";
import ImportPartners from "../pages/colaboradores/ImportPartners.tsx";
import ImportListaNegra from "../pages/lista-negra/ImportListaNegra.tsx";
import Reportes from "../pages/reports/ContractSignedReport.tsx";
import NewPlantilla from "../components/plantilla/NewPlantilla.tsx";
import Plantillas from "../pages/plantillas/Plantillas.tsx";
import Sucursales from "../pages/catalogo/Sucursales.tsx";
import SucursalesForm from "../components/catalogo/Sucursales/SucursalesForm.tsx";
import SucursalesHorio from "../components/catalogo/Sucursales/SucursalesHorio.tsx";
import SucursalesHorioDate from "../components/catalogo/Sucursales/SucursalesHorioDate.tsx";
import ReporteSucursal from "../components/catalogo/Sucursales/ReporteSucursal.tsx";
import RelojChecador from "../pages/reloj-checador/RelojChecador.tsx";
import ConfigPage from "../pages/config/ConfigPage.tsx";
import Assistances from "../components/catalogo/Sucursales/Assistances.tsx";
import ScheduleRealTimeComponent from "../components/catalogo/Sucursales/componentes/ScheduleRealTimeComponent.tsx";
import BirthDatesReport from "../components/catalogo/Sucursales/BirthDatesReport.tsx";
import BirthDatesReportGeneral from "../components/catalogo/Sucursales/BirthDatesReportGeneral.tsx";
import Traspasos from "../pages/traspasos/Traspasos.tsx";
import PartnersByBranch from "../components/catalogo/Sucursales/PartnersByBranch.tsx";
import ReportePlantilla from "../components/catalogo/Sucursales/ReportePlantilla.tsx";
import ResumenHorarios from "../components/catalogo/Sucursales/ResumenHorarios.tsx";
import ResumenHorariosAsistencia from "../components/catalogo/Sucursales/ResumenHorariosAsistencia.tsx";
import Entradas from "../pages/entradas/Entradas.tsx";
import CoberturaPuestos from "../components/catalogo/Sucursales/CoberturaPuestos.tsx";
import RiesgoOperativo from "../components/catalogo/Sucursales/riesgoOperativo/RiesgoOperativo.tsx";
import RiesgoOperativoPage from "../pages/riesgo-operativo/RiesgoOperativoPage.tsx";
import NewContract from "../pages/puestos/NewContract.tsx";
import Chequeo from "../components/catalogo/Sucursales/componentes/Chequeo.tsx";
import ChequeoCodigo from "../components/catalogo/Sucursales/componentes/ChequeoCodigo.tsx";
import DiasSinAsistencia from "../components/catalogo/Sucursales/componentes/DiasSinAsistencia.tsx";
import DiasDescanso from "../components/catalogo/Sucursales/componentes/DiasDescanso.tsx";
import Inasistencias from "../components/catalogo/Sucursales/inaisistencias/Inasistencias.tsx";
import Incidencias from "../components/catalogo/Sucursales/inciencias-legacy/Incidencias.tsx";
import NotificationsUsers from "../pages/notification-user/NotificationsUsers.tsx";
import NewNotification from "../pages/notification-user/components/NewNotification.tsx";
import EditNotification from "../pages/notification-user/components/EditNotification.tsx";
import MyNotifications from "../pages/my-notifications/MyNotifications.tsx";
import EditOrderPosition from "../components/config/EditOrderPosition.tsx";
import CelebrityDaysPage from "../pages/celebrity-days/CelebrityDaysPage.tsx";
import MandatoryDaysPage from "../pages/mandatory-days/MandatoryDaysPage.tsx";
import ReporteSolicitudes from "../pages/solicitudes/ReporteSolicitudes.tsx";
import Reports from "../pages/Reports.tsx";
import TemplateLeaders from "../pages/reports/TemplateLeaders.tsx";
import Badges from "../pages/badges/Badges.tsx";
import ApprovedIncapacity from "../pages/incapacities/ApprovedIncapacity.tsx";
import EditIncapacityPartner from "../pages/incapacities/EditIncapacityPartner.tsx";
import NewIncapacity from "../pages/incapacities/NewIncapacity.tsx";
import NewPermission from "../pages/permissions/NewPermission.tsx";
import ApprovedPermission from "../pages/permissions/ApprovedPermission.tsx";
import EditPermission from "../pages/permissions/EditPermission.tsx";
import ChilitosStats from "../pages/reports/ChilitosStats.tsx";
import DocumentsBranch from "../pages/reports/DocumentsBranch.tsx";
import DocumentsGraphs from "../pages/reports/DocumentsGraphs.tsx";
import Privacy from "../pages/Privacy.tsx";
import DobleFunctionReport from "../components/catalogo/Sucursales/DobleFunctionReport.tsx";
import DobleShiftReport from "../components/catalogo/Sucursales/DobleShiftReport.tsx";
import AllWeekReport from "../components/catalogo/Sucursales/AllWeekReport.tsx";
import SingleWorkDayReport from "../components/catalogo/Sucursales/SingleWorkDayReport.tsx";
import ReportDuplicateDevices from "../components/catalogo/Sucursales/componentes/ReportDuplicateDevices.tsx";
import Inassistence from "../components/catalogo/Sucursales/cubrirPuestos/Inassistence.tsx";
import BranchOrganigrama from "../components/catalogo/Sucursales/componentes/BranchOrganigrama.tsx";
import PageLeader from "../pages/leaderOfLeaders/PageLeader.tsx";
import NominaPage from "../pages/nomina/NominaPage.tsx";
import { NominaHistoryGuard } from "../components/nomina/NominaHistoryGuard.tsx";
import TableIncidents from "../components/incidents/TableIncidents.tsx";
import TableIncidentsDirectBoss from "../components/incidents/TableIncidentsDirectBoss.tsx";
import NominaDetalles from "../pages/nomina/NominaDetalles.tsx";
import BonosPage from "../pages/nomina/BonosPage.tsx";
import DeduccionesPage from "../pages/nomina/DeduccionesPage.tsx";
import TemplateListPage from "../pages/nomina/TemplateListPage.tsx";
import BonusTemplateListPage from "../pages/nomina/BonusTemplateListPage.tsx";
//import Test from "../pages/Test.tsx";
import AllPermissions from "../pages/permissions/AllPermissions.tsx";
import AuthorizedPermissions from "../pages/permissions/AuthorizedPermissions.tsx";
import AllMissingBox from "../pages/missing-box-partner/AllMissingBox.tsx";
import NewMissingBox from "../pages/missing-box-partner/NewMissingBox.tsx";
import EditMissingBox from "../pages/missing-box-partner/EditMissingBox.tsx";
import AllLoans from "../pages/loans/AllLoans.tsx";
import NewLoan from "../pages/loans/NewLoan.tsx";
import EditLoan from "../pages/loans/EditLoan.tsx";
import AllHolidays from "../pages/holidays/AllHolidays.tsx";
import ApprovedHoliday from "../pages/holidays/ApprovedHoliday.tsx";
import AllIncapacities from "../pages/incapacities/AllIncapacities.tsx";
import HolidayBalancesTable from "../pages/holidays/HollidaysTable.tsx";
import AllDirectBoss from "../pages/direct-boss/AllDirectBoss.tsx";
// import Test from "../pages/Test.tsx";
import EmailSettingsPage from "../pages/emails/EmailSettingsPage.tsx";
import IncidentRecoveryPage from "../pages/incident-recovery/IncidentRecoveryPage.tsx";
import EmailTemplatesPage from "../pages/emails/EmailTemplatesPage.tsx";
import EmailTemplateFormPage from "../pages/emails/EmailTemplateFormPage.tsx";
import CheckClarificationsPage from "../pages/check-clarifications/CheckClarificationsPage.tsx";
import FaqsPage from "../pages/faqs/FaqsPage.tsx";
import ListColaboradoresSuspendidos from "../pages/colaboradores-suspendidos/ListColaboradoresSuspendidos.tsx";
import ListControlBajas from "../pages/colaboradores-suspendidos/ListControlBajas.tsx";
import AllComplaints from "../pages/complaints/AllComplaints.tsx";
import NewComplaint from "../pages/complaints/NewComplaint.tsx";
import EditComplaint from "../pages/complaints/EditComplaint.tsx";
import ConfigHorarioSemanal from "../components/catalogo/Sucursales/config-horario-semanal/ConfigHorarioSemanal.tsx";
import TacticaOperativa from "../pages/tactica-operativa/TacticaOperativa.tsx";
import AusentismoPage from "../pages/tactica-operativa/ausentismo/AusentismoPage.tsx";
import PlantillaLideres from "../pages/tactica-operativa/lideres/PlantillaLideres.tsx";
import DocumentsTable from "../pages/documnets/DocumentsTable.tsx";

const AppRoute = [
  {
    path: "*",
    element: <App />,
    children: [
      {
        path: "logout",
        element: <Logout />,
        roles: [
          "Administrador",
          "Lider de sucursal",
          "Reclutamiento",
          "Trabajador",
          "Reclutador/Archivos",
          "Contador",
          "Reclutador",
          "Talento humano",
          "Reloj checador",
          "Capacitación y Cultura",
          "Líder de líderes",
          "Administrador-",
        ],
      },
      {
        path: "",
        element: <Dashboard />,
        roles: [
          "Administrador",
          "Lider de sucursal",
          "Reclutamiento", // Upload files
          "Trabajador",
          "Reclutador/Archivos",
          "Contador",
          "Reclutador",
          "Talento humano",
          "Reloj checador",
          "Capacitación y Cultura",
          "Líder de líderes",
          "Administrador-"
        ],
      },
      {
        path: "documents",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <DocumentsTable />,
            roles: ["Administrador", "Administrador-"],
          },
        ],
      },
      {
        path: "emails",
        element: <Outlet />,
        children: [
          {
            path: "configuracion",
            element: <EmailSettingsPage />,
            roles: ["Administrador"],
          },
          {
            path: "plantillas",
            element: <EmailTemplatesPage />,
            roles: ["Administrador"],
          },
          {
            path: "plantillas/nuevo",
            element: <EmailTemplateFormPage />,
            roles: ["Administrador"],
          },
          {
            path: "plantillas/:id",
            element: <EmailTemplateFormPage />,
            roles: ["Administrador"],
          },
        ],
      },
      {
        path: "centro-incidencias",
        element: <IncidentRecoveryPage />,
        roles: ["Administrador"],
      },
      // {
      //   path: 'test',
      //   element: <Test />,
      //   roles: [
      //     "Administrador",]
      // },
      {
        path: "postulante",
        element: <Outlet />,
        children: [
          {
            path: "form",
            element: <FormPostulante />,
            roles: [
              "Administrador",
              "Lider de sucursal",
              "Reclutamiento",
              "Reclutador",
              "Administrador-"
            ],
          },
          {
            path: "historial/:curp",
            element: <Historial />,
            roles: [
              "Administrador",
              "Administrador-",
              "Lider de sucursal",
              "Reclutamiento",
              "Reclutador",
            ],
          },
        ],
      },
      {
        path: "birthdates",
        element: <BirthDatesReportGeneral />,
        roles: ["Administrador", "Administrador-", "Reclutamiento", "Capacitación y Cultura"],
      },
      {
        path: "tactica-operativa",
        element: <TacticaOperativa />,
        roles: ["Administrador", "Administrador-", "Líder de líderes", "Reclutador"],
      },
      {
        path: "tactica-operativa/ausentismo",
        element: <AusentismoPage />,
        roles: ["Administrador", "Administrador-", "Líder de líderes", "Reclutador"],
      },
      {
        path: "tactica-operativa/lideres",
        element: <PlantillaLideres />,
        roles: ["Administrador", "Administrador-", "Líder de líderes", "Reclutador"],
      },
      {
        path: "reportes",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <Reports />,
            roles: ["Administrador", "Administrador-",],
          },
          {
            path: "contratos-firmados",
            element: <Reportes />,
            roles: ["Administrador", "Administrador-",],
          },
          {
            path: "sucursales",
            element: <ReporteSolicitudes />,
            roles: ["Administrador", "Administrador-",],
          },
          {
            path: "plantilla-lideres",
            element: <TemplateLeaders />,
            roles: ["Administrador", "Administrador-",],
          },
          {
            path: "estadisticas-chilito",
            element: <ChilitosStats />,
            roles: ["Administrador", "Administrador-",],
          },
          {
            path: "documentos/:id",
            element: <DocumentsBranch />,
            roles: ["Administrador", "Administrador-",],
          },
          // { path: "/cumpleaños", element: <Reportes />, roles: ["Administrador"] },
        ],
      },
      {
        path: "graficas",
        element: <DocumentsGraphs />,
        roles: ["Administrador", "Administrador-",],
      },
      {
        path: "result",
        element: <Outlet />,
        children: [
          {
            path: "form",
            element: <FormResult />,
            roles: [
              "Administrador",
              "Lider de sucursal",
              "Reclutador/Archivos",
              "Reclutador",
              "Administrador-",
            ],
          },
        ],
      },
      {
        path: "solicitudes/",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <ListSolicitudes />,
            roles: [
              "Administrador",
              "Lider de sucursal",
              "Reclutador/Archivos",
              "Reclutador",
              "Administrador-",
            ],
          },
          {
            path: "tracking/:id",
            element: <CandidateTracking />,
            roles: [
              "Administrador",
              "Lider de sucursal",
              "Reclutador/Archivos",
              "Reclutador",
              "Administrador-",
            ],
          },
          {
            path: "aprobar/:id",
            element: <FetchCollaborator />,
            roles: ["Administrador", "Administrador-", "Lider de sucursal", "Reclutador"],
          },
        ],
      },
      {
        path: "colaboradores/",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <ListColaboradores />,
            roles: [
              "Administrador",
              "Administrador-",
              "Lider de sucursal",
              "Contador",
              "Reclutador",
              "Talento humano",
            ],
          },
          {
            path: "suspendidos",
            element: <ListColaboradoresSuspendidos />,
            roles: [
              "Administrador",
              "Administrador-",
              "Lider de sucursal",
              "Talento humano",
            ],
          },
          {
            path: "control-bajas",
            element: <ListControlBajas />,
            roles: [
              "Administrador",
              "Administrador-",
              "Lider de sucursal",
              "Talento humano",
            ],
          },
          {
            path: "detalles/:id",
            element: <ProfilePartner />,
            roles: [
              "Administrador",
              "Administrador-",
              "Lider de sucursal",
              "Contador",
              "Reclutador",
              "Talento humano",
              "Líder de líderes"
            ],
          },
          {
            path: "aprobar-incapacidad/:id",
            element: <ApprovedIncapacity />,
            roles: ["Administrador", "Administrador-", "Lider de sucursal", "Trabajador"],
          },
          {
            path: "nueva-incapacidad/:id",
            element: <NewIncapacity />,
            roles: ["Administrador", "Administrador-", "Lider de sucursal"],
          },
          {
            path: "nuevo-permiso/:id",
            element: <NewPermission />,
            roles: ["Administrador", "Administrador-", "Lider de sucursal"],
          },
          {
            path: "aprobar-permiso/:id",
            element: <ApprovedPermission />,
            roles: ["Administrador", "Administrador-", "Lider de sucursal", "Trabajador"],
          },
          {
            path: "editar-permiso/:id",
            element: <EditPermission />,
            roles: ["Administrador", "Administrador-", "Lider de sucursal"],
          },

          {
            path: "importar",
            element: <ImportPartners />,
            roles: ["Administrador", "Administrador-", "Lider de sucursal"],
          },
        ],
      },
      {
        path: "revision-documentos",
        element: <DocumentsReview />,
        roles: [
          "Administrador",
          "Administrador-",
          "Reclutamiento",
          "Reclutador",
          "Talento humano",
          "Lider de sucursal",
        ],
      },
      {
        path: "calendar",
        element: <Calendar />,
        roles: ["Administrador", "Administrador-", "Reclutador"],
      },
      {
        path: "leader-calendar",
        element: <LeaderCalendar />,
        roles: [
          "Lider de sucursal",
          "Líder de Sucursal SUC",
          "Líder de Sucursal",
          "Líder de líderes",
        ],
      },
      {
        path: "catalog",
        element: <ListCatalog />,
        roles: ["Administrador", "Administrador-"],
      },
      {
        path: "usuarios/",
        element: <Outlet />,
        children: [
          // Si no agregamos roles es poque solo es para admin
          {
            path: "",
            element: <ListUsers />,
            roles: ["Administrador", "Administrador-",],
          },
          { path: "nuevo", element: <NewUser />, roles: ["Administrador", "Administrador-",] },
          {
            path: "editar/:id",
            element: <EditUser />,
            roles: ["Administrador", "Administrador-",],
          },
        ],
      },
      {
        path: "login",
        element: <Navigate to="/" />,
      },
      {
        path: "form",
        element: <Outlet />,
        children: [
          {
            path: "elements",
            element: <FormElements />,
            roles: ["Administrador", "Administrador-", "Lider de sucursal"],
          },
          {
            path: "plugins",
            element: <FormPlugins />,
            roles: ["Administrador", "Administrador-", "Lider de sucursal"],
          },
        ],
      },
      {
        path: "user",
        element: <Outlet />,
        children: [
          { path: "login-v1", element: <LoginV1 /> },
          { path: "login-v2", element: <LoginV2 /> },
          { path: "login-v3", element: <LoginV3 /> },
          { path: "register-v3", element: <RegisterV3 /> },
        ],
      },
      {
        path: "helper/css",
        element: <HelperCSS />,
      },
      {
        path: "vacantes",
        element: <Outlet />,
        children: [
          {
            path: "",
            // element: <Vacantes />,
            element: <VacantesV2 />,
            roles: ["Administrador", "Administrador-", "Reclutador"],
          },
        ],
      },
      {
        path: "lista-negra",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <ListListaNegra />,
            roles: ["Administrador", "Administrador-", "Reclutador", "Talento humano"],
          },
          {
            path: "importar",
            element: <ImportListaNegra />,
            roles: ["Administrador", "Administrador-",],
          },
        ],
      },
      {
        path: "mi-expediente",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <MyExpedient />,
            roles: ["Trabajador", "Jefe directo"],
          },
          {
            path: "incapacidad/:id",
            element: <EditIncapacityPartner />,
            roles: ["Trabajador", "Jefe directo"],
          },
          {
            path: "nuevo/:id",
            element: <NewIncapacity />,
            roles: ["Trabajador", "Administrador", "Administrador-", "Jefe directo"],
          },
        ],
      },
      {
        path: "insignias",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <Badges />,
            roles: ["Administrador", "Reclutamiento", "Administrador-",],
          },
        ],
      },
      {
        path: "puestos",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <Puestos />,
            roles: ["Administrador", "Administrador-", "Reclutamiento"],
          },
          {
            path: "nuevo",
            element: <NewPosition />,
            roles: ["Administrador", "Administrador-", "Reclutamiento"],
          },
          {
            path: "nuevo-contrato",
            element: <NewContract />,
            roles: ["Administrador", "Administrador-", "Reclutamiento"],
          },
          {
            path: "editar/:id",
            element: <EditPosition />,
            roles: ["Administrador", "Administrador-", "Reclutamiento"],
          },
        ],
      },
      {
        path: "plantillas",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <Plantillas />,
            roles: ["Administrador", "Administrador-", "Reclutamiento"],
          },
          {
            path: "nuevo",
            element: <NewPlantilla />,
            roles: ["Administrador", "Administrador-", "Reclutamiento"],
          },
          {
            path: "editar/:id",
            element: <NewPlantilla />,
            roles: ["Administrador", "Administrador-", "Reclutamiento"],
          },
        ],
      },
      {
        path: "mis-notificaciones",
        element: <MyNotifications />,
        roles: [
          "Administrador",
          "Administrador-",
          "Lider de sucursal",
          "Reclutamiento",
          "Trabajador",
          "Reclutador/Archivos",
          "Contador",
          "Reclutador",
          "Talento humano",
          "Reloj checador",
          "Capacitación y Cultura",
          "Líder de líderes",
        ],
      },
      {
        path: "notificaciones",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <NotificationsUsers />,
            roles: ["Administrador", "Administrador-", "Reclutamiento"],
          },
          {
            path: "nueva-notificacion",
            element: <NewNotification />,
            roles: ["Administrador", "Administrador-", "Reclutamiento"],
          },
          {
            path: "editar/:id",
            element: <EditNotification />,
            roles: ["Administrador", "Administrador-", "Reclutamiento"],
          },
        ],
      },
      {
        path: "sucursales",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <Sucursales />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", 'Líder de líderes'],
          },
          {
            path: "incidencias-legacy/:id",
            element: <Incidencias />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "incidencias/:id",
            element: <TableIncidents />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "chequeo",
            element: <Chequeo />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "incidencias",
            element: <TableIncidents />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "chequeo/:id",
            element: <Chequeo />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "reporte-codigo/:id",
            element: <ChequeoCodigo />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "dias-sin-asistencia/:id",
            element: <DiasSinAsistencia />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "dias-descanso/:id",
            element: <DiasDescanso />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "inasistencias",
            element: <Inasistencias />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "inasistencias/:id",
            element: <Inasistencias />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "nuevo",
            element: <SucursalesForm />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "editar/:id",
            element: <SucursalesForm />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "birthdates",
            element: <BirthDatesReportGeneral />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Capacitación y Cultura", "Líder de líderes"],
          },
          {
            path: "birthdates/:id",
            element: <BirthDatesReport />,
            roles: [
              "Administrador",
              "Reclutamiento",
              "Lider de sucursal",
              "Capacitación y Cultura",
              "Líder de líderes",
              "Administrador-"
            ],
          },
          {
            path: "colaboradores/:id",
            element: <PartnersByBranch />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "horario/:id",
            element: <SucursalesHorio />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "horario-fecha/:id",
            element: <SucursalesHorioDate />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "reporte/:id",
            element: <ReporteSucursal />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "reporte-plantilla/:id",
            element: <ReportePlantilla />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "cobertura-puestos/:id",
            element: <CoberturaPuestos />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "riesgo-operativo/:id",
            element: <RiesgoOperativo />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "resumen-horario/:id",
            element: <ResumenHorarios />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "resumen-horario-asistencia/:id",
            element: <ResumenHorariosAsistencia />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "resumen-all-week/:id",
            element: <AllWeekReport />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "resumen-doble-funcion/:id",
            element: <DobleFunctionReport />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "resumen-duplicate-device/:id",
            element: <ReportDuplicateDevices />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "organigrama-workers/:id",
            element: <BranchOrganigrama />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "resumen-single-work/:id",
            element: <SingleWorkDayReport />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "resumen-doble-turno/:id",
            element: <DobleShiftReport />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
          },
          {
            path: "asistencias",
            element: <Assistances />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal", "Líder de líderes"],
          },
          {
            path: "asistencias/colaborador/:id",
            element: <Assistances />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal", "Líder de líderes"],
          },
          {
            path: "asistencias/:id/horario",
            element: <ScheduleRealTimeComponent />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal", "Líder de líderes"],
          },
          {
            path: "traspasos/:id",
            element: <Traspasos />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal", "Líder de líderes"],
          },
          {
            path: "cubrir-puestos-urgente/:id",
            element: <Inassistence />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal", "Líder de líderes"],
          },
          {
            path: "Aclaraciones-horario/:id",
            element: <CheckClarificationsPage />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal", "Líder de líderes"],
          },
          {
            path: "Aclaraciones-horario/:id/revisar/:clarificationId",
            element: <CheckClarificationsPage />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal", "Líder de líderes"],
          },
          {
            path: "config-horario-semanal/:id",
            element: <ConfigHorarioSemanal />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal", "Líder de líderes"],
          },
          {
            path: "config-horario-semanal",
            element: <ConfigHorarioSemanal />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal", "Líder de líderes"],
          },
          {
            path: "*",
            element: <ExtraError />,
            roles: [
              "Administrador",
              "Lider de sucursal",
              "Reclutamiento",
              "Trabajador",
              "Reclutador/Archivos",
              "Contador",
              "Reclutador",
              "Talento humano",
              "Capacitación y Cultura",
              "Líder de líderes",
              "Administrador-"
            ],
          },
        ],
        roles: ['Líder de líderes']
      },
      {
        path: "riesgo-operativo",
        element: <RiesgoOperativoPage />,
        roles: ["Administrador", "Administrador-", "Reclutamiento", "Líder de líderes"],
      },
      {
        path: "sucursal",
        element: <Outlet />,
        children: [
          {
            path: "colaboradores",
            element: <PartnersByBranch />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal"],
          },
          {
            path: "birthdates",
            element: <BirthDatesReport />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal"],
          },
          {
            path: "horario",
            element: <SucursalesHorio />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal"],
          },
          {
            path: "horario-fecha",
            element: <SucursalesHorioDate />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal"],
          },
          {
            path: "reporte",
            element: <ReporteSucursal />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal"],
          },
          {
            path: "reporte-plantilla",
            element: <ReportePlantilla />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal"],
          },
          {
            path: "resumen-horario",
            element: <ResumenHorarios />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal"],
          },
          {
            path: "resumen-horario-asistencia",
            element: <ResumenHorariosAsistencia />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal"],
          },
          {
            path: "asistencias",
            element: <Assistances />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal"],
          },
          {
            path: "asistencias/colaborador/:id",
            element: <Assistances />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal"],
          },
          {
            path: "asistencias/:id/horario",
            element: <ScheduleRealTimeComponent />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal"],
          },
          {
            path: "traspasos",
            element: <Traspasos />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal"],
          },
          {
            path: "incidencias",
            element: <TableIncidents />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal"],
          },
          {
            path: "reporte-reloj",
            element: <Chequeo />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal"],
          },
          {
            path: "dias-sin-asistencia",
            element: <DiasSinAsistencia />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal"],
          },
          {
            path: "dias-descanso",
            element: <DiasDescanso />,
            roles: ["Administrador", "Administrador-", "Reclutamiento", "Lider de sucursal"],
          },
        ],
      },
      {
        path: "reloj-checador",
        element: <RelojChecador />,
        roles: ["Administrador", "Administrador-", "Lider de sucursal", "Reloj checador"],
      },
      {
        path: "configuracion",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <ConfigPage />,
            roles: ["Administrador", "Administrador-", "Reclutamiento"],
          },
          {
            path: "order-puestos",
            element: <EditOrderPosition />,
            roles: ["Administrador", "Administrador-", "Reclutamiento"],
          },
          {
            path: "dias-festivos",
            element: <CelebrityDaysPage />,
            roles: ["Administrador", "Administrador-", "Reclutamiento"],
          },
          {
            path: "dias-obligatorios",
            element: <MandatoryDaysPage />,
            roles: ["Administrador", "Administrador-", "Reclutamiento"],
          },
          {
            path: "faqs",
            element: <FaqsPage />,
            roles: ["Administrador", "Administrador-", "Reclutamiento"],
          },
        ],
      },
      {
        path: "registro-de-entradas",
        element: <Entradas />,
        children: [
          {
            path: "",
            element: <ConfigPage />,
            roles: ["Administrador", "Administrador-", "Reclutamiento"],
          },
        ],
      },
      {
        path: "nomina",
        element: <NominaHistoryGuard />,
        children: [
          {
            path: "",
            element: <NominaPage />,
            roles: ["Administrador"],
          },
          {
            path: "detalles",
            element: <NominaDetalles />,
            roles: ["Administrador"],
          },
          {
            path: "bonos",
            element: <BonosPage />,
            roles: ["Administrador"],
          },
          {
            path: "deducciones",
            element: <DeduccionesPage />,
            roles: ["Administrador"],
          },
          {
            path: "plantillas",
            element: <TemplateListPage />,
            roles: ["Administrador"],
          },
          {
            path: "plantillas-bonos",
            element: <BonusTemplateListPage />,
            roles: ["Administrador"],
          },
        ],
      },
      {
        path: "direct-boss",
        element: <AllDirectBoss />,
        roles: ["Administrador", "Lider de sucursal"],
      },
      {
        path: "permisos",
        element: <AllPermissions />,
        roles: ["Administrador", "Lider de sucursal", "Trabajador"],
      },
      {
        path: "permisos/autorizados",
        element: <AuthorizedPermissions />,
        roles: ["Administrador", "Lider de sucursal"],
      },
      {
        path: "permisos/:bossId",
        element: <AllPermissions />,
        roles: ["Trabajador"],
      },
      {
        path: "vacaciones",
        element: <AllHolidays />,
        roles: ["Administrador", "Lider de sucursal", "Trabajador"],
      },
      {
        path: "vacaciones/:bossId",
        element: <AllHolidays />,
        roles: ["Trabajador"],
      },
      {
        path: "vacaciones-tabla",
        element: <HolidayBalancesTable />,
        roles: ["Administrador", "Lider de sucursal", "Trabajador"],
      },
      {
        path: "vacaciones-tabla/:bossId",
        element: <HolidayBalancesTable />,
        roles: ["Trabajador"],
      },
      {
        path: "colaboradores/aprobar-vacaciones/:id",
        element: <ApprovedHoliday />,
        roles: ["Administrador", "Administrador-", "Lider de sucursal", "Trabajador"],
      },
      {
        path: "incapacidades",
        element: <AllIncapacities />,
        roles: ["Administrador", "Lider de sucursal", "Trabajador"],
      },
      {
        path: "incapacidades/:bossId",
        element: <AllIncapacities />,
        roles: ["Trabajador"],
      },
      {
        path: "incidencias/:bossId",
        element: <TableIncidentsDirectBoss />,
        roles: ["Trabajador"],
      },
      {
        path: "colaboradores/aprobar-incapacidad/:id",
        element: <ApprovedIncapacity />,
        roles: ["Administrador", "Administrador-", "Lider de sucursal", "Trabajador"],
      },
      {
        path: "faltantes-caja",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <AllMissingBox />,
            roles: ["Administrador", "Lider de sucursal"],
          },
          {
            path: "nuevo",
            element: <NewMissingBox />,
            roles: ["Administrador", "Lider de sucursal"],
          },
          {
            path: "editar/:id",
            element: <EditMissingBox />,
            roles: ["Administrador", "Lider de sucursal"],
          },
        ],
      },
      {
        path: "prestamos",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <AllLoans />,
            roles: ["Administrador", "Lider de sucursal"],
          },
          {
            path: "nuevo",
            element: <NewLoan />,
            roles: ["Administrador", "Lider de sucursal"],
          },
          {
            path: "editar/:id",
            element: <EditLoan />,
            roles: ["Administrador", "Lider de sucursal"],
          },
        ],
      },
      {
        path: "quejas",
        element: <Outlet />,
        children: [
          {
            path: "",
            element: <AllComplaints />,
            roles: ["Administrador", "Administrador-", "Lider de sucursal", "Talento humano"],
          },
          {
            path: "nuevo",
            element: <NewComplaint />,
            roles: ["Administrador", "Administrador-", "Lider de sucursal", "Talento humano"],
          },
          {
            path: "editar/:id",
            element: <EditComplaint />,
            roles: ["Administrador", "Administrador-", "Lider de sucursal", "Talento humano"],
          },
        ],
      },
      {
        path: "*",
        element: <ExtraError />,
        roles: [
          "Administrador",
          "Lider de sucursal",
          "Reclutamiento",
          "Trabajador",
          "Reclutador/Archivos",
          "Contador",
          "Reclutador",
          "Talento humano",
          "Capacitación y Cultura",
          "Líder de líderes",
          "Administrador-",
        ],
      },
    ],
  },
];

export const PublicRoutes = [
  {
    path: "politica-de-privacidad",
    element: <Privacy />,
  },
  {
    path: "logout",
    element: <Logout />,
  },
  {
    path: "login",
    element: <LoginV2 />,
  },
  {
    path: "unete",
    element: <Outlet />,
    children: [{ path: "", element: <LoginV3 /> }],
  },
  {
    path: "preguntas-iniciales",
    element: <Outlet />,
    children: [
      { path: "form", element: <FormPreguntasInciales /> },
      { path: "confirmation", element: <Confirmation /> },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/unete" />,
  },
];

export default AppRoute;
